module.exports = __webpack_public_path__ + "static/Time-f53b8819904db9d726c4ac5b60d3f87b.svg";